import React from 'react';

export default React.createContext({
  darkMode: false,
  setDarkMode: () => {},
});
